module.exports = __webpack_public_path__ + "img/banner-title.8737492f.png";